import { render, staticRenderFns } from "./Licensedisplay.vue?vue&type=template&id=4d0ce2e6&scoped=true&"
import script from "./Licensedisplay.vue?vue&type=script&lang=js&"
export * from "./Licensedisplay.vue?vue&type=script&lang=js&"
import style0 from "./Licensedisplay.vue?vue&type=style&index=0&id=4d0ce2e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ce2e6",
  null
  
)

export default component.exports